export default __webpack_public_path__ + "static/media/ReadyToInspectStopwatch.f53c1c9e.svg";